export class ApplicationSettings {
  bffEndpoint: string;
  keyCloakUlr: string;
  googleTimezoneAPIURL: string;
  googleAPIKey: string;
  caseManagementSystemEndpoint: string;
  atlasApiServiceEndpoint: string;
  atlasAccessRole: string;
  reserveSuggestionEnabled: boolean;
  ssoDisabled: boolean;
  isProduction: boolean;
  isTest: boolean;
  providerEndpoint: string;
  openCasesMaxCount: number;
  openCasesWarningThreshold: number;
  pageableSize: number;
  feature: object;
  isRecoveryPaymentMovementEnabled: boolean;
  constructor() {
    this.bffEndpoint = '';
  }
}
